var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 4,
    viewBox: "0 0 20 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#1C2026"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 10,
    cy: 2,
    r: 2,
    fill: "#1C2026"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 18,
    cy: 2,
    r: 2,
    fill: "#1C2026"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreMenu);
export default __webpack_public_path__ + "static/media/more-menu.c23e66ac05f499a71f6d8b3bf8748a12.svg";
export { ForwardRef as ReactComponent };